<script>
    import countdown from 'countdown'
    import { mapGetters } from 'vuex'

    export default {
        props: {
            start: {
                default: null,
            },
            end: {
                default: null,
            },
            units: {
                default: countdown.DEFAULTS
            },
            max: {
                default: 2,
            },
            digits: {
                default: 0,
            }
        },

        data() {
            return {
                countdown: null,
                timeLeft: '',
            }
        },

        created() {
            this.setLabels();
            this.startCountdown();
        },

        destroyed() {
            clearInterval(this.countdown);
        },

        render() {
            return this.$scopedSlots.default({
                countdown: this.timeLeft,
            });
        },

        computed: {
            ...mapGetters('general', ["lang"]),
        },

        methods: {
            formatter(value, unit) {
                var ONE = ' millisekundę| sekundę| minutę| godzinę| dzień| tydzień| miesiąc| rok|||'.split('|');
                var FEW = ' millisekundy| sekundy| minuty| godziny| dni | tygodnie| miesiące| lata|||'.split('|');
                var MANY = ' millisekund| sekund| minut| godzin| dni| tygodni|miesięcy| lat|||'.split('|');
                var singular = value % 10;
                var plural = Math.floor((value % 100) / 10);

                if (value == 1) {
                    return value + ONE[unit];
                }
                else if (singular >= 2 && singular <= 4 && plural != 1) {
                    return value + FEW[unit];
                }
                else if (singular == 1 && plural != 1) {
                    return value + ONE[unit];
                }
                else {
                    return value + MANY[unit];
                }
            },

            setLabels() {
                countdown.resetLabels();

                if (this.lang == "sv") {
                    countdown.setLabels(
                        ' millisekund| sekund| minut| timme| dag| vecka| månad| år|||',
                        ' millisekunder| sekunder| minuter| timmar| dagar| veckor| månader| år|||',
                        ' och ',
                        ', ',
                        'nu'
                    );
                }
                if (this.lang == "pl") {
                    countdown.setFormat({
                        last: ' i ',
                        decim: ',',
                        empty: "nu",
                        formatter: this.formatter
                    });
                }
            },

            startCountdown() {
                this.countdown = countdown(
                    this.start ? new Date(this.format(this.start)) : this.timer,
                    this.end ? new Date(this.format(this.end)) : this.timer,
                    this.units,
                    this.max,
                    this.digits
                );
            },

            timer(ts) {
                this.timeLeft = ts.toString()
            },

            format(date) {
                return date.replace(" ", "T")
            }
        },
    }
</script>
